import React, { Fragment, useState, useEffect } from 'react';

import Breadcrumbs from '../../../CommonComponents/Breadcrumbs/Breadcrumbs';

import { NAVS } from './constants';
import './HeaderMove.scss';

export const HeaderMove = ({ baseImgUrl }) => {
  const [poster, setPoster] = useState(`${baseImgUrl}/about-video-poster_pc.webp`);

  const title = 'OWNDAYS | MOVE | Eyewear for the active';
  const breadcrumbs = [
    { path: '/sg/en', label: 'Homepage' },
    { path: '/sg/en/news', label: 'News' },
    { path: '#', label: 'OWNDAYS | MOVE' },
  ];

  const scrollToSection = id => {
    if (!id) return;

    const elementId = id.startsWith('#') ? id.substring(1) : id;
    const element = document.getElementById(elementId);

    window.location.hash = elementId;

    if (element) {
      const headerOffset = document.querySelector('header')?.offsetHeight || 0;
      const elementTop = element.getBoundingClientRect().top + window.scrollY;

      window.scrollTo({
        top: elementTop - headerOffset,
        behavior: 'smooth',
      });
    }
  };

  useEffect(() => {
    if (window.location.hash) {
      setTimeout(() => {
        scrollToSection(window.location.hash);
      }, 0);
    }
  }, []);

  useEffect(() => {
    if (window.Fancybox) {
      window.Fancybox.bind("[data-fancybox='etc']", {});
    }
  }, []);

  useEffect(() => {
    const updatePoster = () => {
      const isMobile = window.innerWidth <= 430;
      const newPoster = isMobile
        ? `${baseImgUrl}/about-video-poster_sp.webp`
        : `${baseImgUrl}/about-video-poster_pc.webp`;
      setPoster(newPoster);
    };

    updatePoster();

    window.addEventListener('resize', updatePoster);

    return () => window.removeEventListener('resize', updatePoster);
  }, [baseImgUrl]);

  return (
    <Fragment>
      <Breadcrumbs crumbs={breadcrumbs} />

      <section className="header-move__main">
        <div className="header-move__main__bg">
          <picture>
            <source media="(min-width: 768px)" srcSet={`${baseImgUrl}/main_pc.webp`} />
            <img alt={title} loading="lazy" src={`${baseImgUrl}/main_sp.webp`} />
          </picture>
        </div>

        <div className="header-move__main__text">
          <div className="base-move__container">
            <h1>
              <img alt={title} loading="lazy" src={`${baseImgUrl}/move_logo.svg`} />
            </h1>
            <h2>Eyewear for the active.</h2>
          </div>
        </div>
      </section>

      <section className="header-move__about">
        <div className="header-move__about__bg">
          <video autoPlay loop muted playsInline>
            <source media="(min-width:768px)" src={`${baseImgUrl}/video-pc.mp4`} type="video/mp4" />
            <source src={`${baseImgUrl}/video-sp.mp4`} type="video/mp4" />
          </video>
        </div>

        <div className="header-move__about__text">
          <div className="header-move__about__container">
            <p>
              Designed for a secure fit that stays in place even during active movement. Perfect for
              everyday life and on-the-go moments.
            </p>
          </div>
        </div>

        <a
          className="header-move__about__play"
          data-fancybox="etc"
          href="https://youtu.be/FwwAcfYCZlQ"
        >
          Play
        </a>
      </section>

      <section className="header-move__navs">
        <div className="base-move__container">
          <ul>
            {NAVS.map(text => (
              <li key={text} onClick={() => scrollToSection(text.toLowerCase().replace(' ', '-'))}>
                <a>{text}</a>
              </li>
            ))}
          </ul>
        </div>
      </section>
    </Fragment>
  );
};
